<a sd-button
   class="cms-link-ds"
   type="button"
   [href]="link?.url"
   [target]="target"
   [brand]="brandCorner"
>
  {{ linkName }}
</a>
